import { NOTIFIER_HIDE } from 'components/notifier/constants';

var notifierHide = function notifierHide(id, force) {
  return {
    type: NOTIFIER_HIDE,
    payload: {
      id: id,
      force: force
    }
  };
};

export { notifierHide };